class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.prepareHostHeader();
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    const modal = this.detailsContainer.querySelector('[tabindex="-1"]');
    const input = this.detailsContainer.querySelector('input:not([type="hidden"])');
    const focusTarget = input || modal;

    trapFocus(modal, focusTarget, true);
  }

  close(focusToggle = true) {
    const returnFocus = focusToggle ? this.zicoReturnFocus || this.summaryToggle : null;
    removeTrapFocus(returnFocus);
    this.zicoReturnFocus = null;
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    this.restoreHostHeader();

    if (returnFocus?.isConnected) {
      const restoreFocus = () => returnFocus.focus({ preventScroll: true });
      window.requestAnimationFrame(restoreFocus);
      window.setTimeout(restoreFocus, 120);
    }
  }

  prepareHostHeader() {
    const header = this.closest('.section-header, .shopify-section-header');
    if (!header || this.hostHeaderState) return;

    this.hostHeaderState = {
      header,
      hidden: header.classList.contains('shopify-section-header-hidden'),
      sticky: header.classList.contains('shopify-section-header-sticky'),
      animate: header.classList.contains('animate'),
    };

    header.classList.add('shopify-section-header-sticky');
    header.classList.remove('shopify-section-header-hidden', 'animate');
  }

  restoreHostHeader() {
    const state = this.hostHeaderState;
    this.hostHeaderState = null;
    if (!state?.header?.isConnected) return;

    state.header.classList.toggle('shopify-section-header-hidden', state.hidden);
    state.header.classList.toggle('shopify-section-header-sticky', state.sticky);
    state.header.classList.toggle('animate', state.animate);
  }
}

customElements.define('details-modal', DetailsModal);
